export const TOP_NAV = {
  // actual: '/actual',
  strategies: '/strategies',
  markets: '/markets',
  inspiration: '/inspiration',
};

export const USER_NAV = {
  account: '/account',
  subscriptions: '/subscriptions',
  payments: '',
  support: '/support',
  contacts: '/contacts',
  feedback: '/feedback',
  referFriend: '/referral',
  switchUIMode: '',
  switchAccount: '',
  language: '',
  privacyAndTerms: '/privacy-and-terms',
  logout: '/logout',
};
